import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import mainActions from "../../redux/main/actions";
import bgFlag from "../../images/flags/bg.png";
import enFlag from "../../images/flags/uk.png";
import "./index.css";

const Header = () => {
  const { companiesDetails, selectedLanguage } = useSelector(
    (state) => state.mainReducer
  );
  const dispatch = useDispatch();
  const { setOpenMenuDrawer } = mainActions;
  const { t, i18n } = useTranslation();

  const handleOpenMenuDrawer = () => {
    dispatch(setOpenMenuDrawer(true));
  };

  const handleLanguageChange = (value) => {
    i18n.changeLanguage(value);
    localStorage.setItem("selectedLanguage", value);
    window.location.reload();
  };

  useEffect(() => {
    if (selectedLanguage && selectedLanguage !== i18n.language) {
      i18n.changeLanguage(selectedLanguage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n]);

  const languageOptions = [
    {
      value: "bg",
      label: (
        <div>
          <img
            className="google-translate-select-flag"
            src={bgFlag}
            alt="bg-flag"
          />
          <span>BG</span>
        </div>
      ),
    },
    {
      value: "en",
      label: (
        <div>
          <img
            className="google-translate-select-flag"
            src={enFlag}
            alt="en-flag"
          />
          <span>EN</span>
        </div>
      ),
    },
  ];

  const { Option } = Select;

  return (
    <header className="header">
      <nav className="navbar nav-container">
        <Link to="/">
          {companiesDetails?.length !== 0 && (
            <img
              alt="logo"
              className="navbar-logo"
              src={`data:image/jpeg;base64,${companiesDetails?.logo}`}
            />
          )}
        </Link>
        <div className="menu" id="menu">
          <ul className="menu-inner">
            <li className="menu-item">
              <Link to="/" className="menu-link">
                {t("home")}
              </Link>
            </li>
            <li className="menu-item">
              <Link to="/refund-ticket" className="menu-link">
                {t("ticketRevalidation")}
              </Link>
            </li>
            {/* <li className="menu-item">
              <Link to="/favorite-destination" className="menu-link">
                {t("favoriteDestinations")}
              </Link>
            </li> */}
            <li className="menu-item">
              <Link to="/personal-information" className="menu-link">
                {t("personalInfo")}
              </Link>
            </li>

            <li className="menu-item">
              <Link to="/order-history" className="menu-link">
                {t("orderHistory")}
              </Link>
            </li>
          </ul>
        </div>
        <div className="burger-container">
          <div onClick={handleOpenMenuDrawer} className="burger">
            <span className="burger-line"></span>
            <span className="burger-line"></span>
            <span className="burger-line"></span>
          </div>
        </div>
        <Select
          className="google-translate-select"
          style={{ border: "none" }}
          value={i18n.language}
          onChange={handleLanguageChange}
          suffixIcon={null}
          bordered={false}
        >
          {languageOptions.map((option) => (
            <Option key={option.value} value={option.value}>
              <span className="remove-pointer-events">{option.label}</span>
            </Option>
          ))}
        </Select>
      </nav>
    </header>
  );
};

export default Header;
